<template>
  <div class="wrapper" v-if="visible">
    <PhoneLogin v-if="mode === 'phone'" @login="onlogin" @changeMode="changeMode" @updateCommonData="updateCommonData" @linkOutTo="linkOutTo" />
    <AccountLogin v-if="mode === 'account'" @login="onlogin" @changeMode="changeMode" @updateCommonData="updateCommonData" @linkOutTo="linkOutTo" />
  </div>
</template>

<script>
  import PhoneLogin from './PhoneLogin'
  import AccountLogin from './AccountLogin'

  export default {
    data() {
      return {
        visible: false,
        mode: 'phone',  /*phone, account*/
        commonData: {}
      }
    },
    provide() {
      return {
        commonData: this.commonData
      }
    },
    mounted() {
      window.addEventListener('popstate', this.close)
    },
    destroyed(){
      window.removeEventListener('popstate', this.close)
    },
    methods: {
      show(payload={}){
        history.pushState({}, '')
        this.updateCommonData(payload)
        this.visible = true
      },
      close(){
        this.visible = false
      },
      onlogin(userInfo){
        this.$emit('login', userInfo)
        history.back()
      },
      changeMode(mode='phone'){
        this.mode = mode
      },
      updateCommonData(data={}){
        this.commonData = Object.assign(this.commonData, data)
      },
      linkOutTo(url){
        history.back()
        window.location.href = url
      }
    },
    components: {
      PhoneLogin, AccountLogin
    }
  }
</script>

<style lang="css" scoped>
  .wrapper{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
    overflow: hidden;
    z-index: 999;
  }
</style>
